import React, { useState, useEffect } from 'react';
import { Phone, MessageCircle, Menu, X } from 'lucide-react';
import Logo from './Logo';
import { contactInfo } from '../data/mockData';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Logo className="cursor-pointer" />

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('home')} className="nav-link">Home</button>
            <button onClick={() => scrollToSection('products')} className="nav-link">Products</button>
            <button onClick={() => scrollToSection('about')} className="nav-link">About</button>
            <button onClick={() => scrollToSection('contact')} className="nav-link">Contact</button>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={`tel:919713889720`}
              className="btn-secondary flex items-center gap-2"
            >
              <Phone size={18} />
              Call Now
            </a>
            <a
              href={`https://wa.me/919713889720?text=${encodeURIComponent('Hello, I want to know about your fabric products')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary flex items-center gap-2"
            >
              <MessageCircle size={18} />
              WhatsApp
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t animate-fadeIn">
            <nav className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('home')} className="nav-link-mobile">Home</button>
              <button onClick={() => scrollToSection('products')} className="nav-link-mobile">Products</button>
              <button onClick={() => scrollToSection('about')} className="nav-link-mobile">About</button>
              <button onClick={() => scrollToSection('contact')} className="nav-link-mobile">Contact</button>
              
              <div className="flex flex-col gap-3 mt-4">
                <a
                  href={`tel:919713889720`}
                  className="btn-secondary flex items-center justify-center gap-2"
                >
                  <Phone size={18} />
                  Call Now
                </a>
                <a
                  href={`https://wa.me/919713889720?text=${encodeURIComponent('Hello, I want to know about your fabric products')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary flex items-center justify-center gap-2"
                >
                  <MessageCircle size={18} />
                  WhatsApp
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
